'use client'

import DOMPurify from 'dompurify'
import React from 'react'

import { cn } from '../../../utils/cn'

import { HeroAContent, HeroAImage } from './_components'

import type { IMHeroAProps } from './_types/types'

/**
 * MHeroA – presentational hero section (detail-hero style).
 * Content column (title, text, buttons) + image column.
 * Uses subcomponents and shared styles; responsive (stacked on mobile, side-by-side on lg).
 */
export const MHeroA: React.FC<IMHeroAProps> = ({
	className,
	style,
	image,
	eyebrow,
	title,
	text,
	buttons
}) => {
	const sanitizedTitle = typeof window !== 'undefined' ? DOMPurify.sanitize(title) : title
	const sanitizedText = typeof window !== 'undefined' ? DOMPurify.sanitize(text) : text

	return (
		<section className={cn('m-hero-a', className)} style={style}>
			<HeroAContent
				eyebrow={eyebrow}
				title={sanitizedTitle}
				text={sanitizedText}
				buttons={buttons}
			/>
			<HeroAImage image={image} />
		</section>
	)
}

MHeroA.displayName = 'MHeroA'
